<template>
  <div>
    <h1 class="section-divider-underline">
      {{ $t("employeeProfile.payroll") }}
    </h1>
    <div class="row">
      <div class="col-md-6 tw-space-y-4">
        <div class="row">
          <label class="form-col-label control-label col-md-5"></label>
          <div class="col-md-7 tw-space-x-2">
            <input
              type="checkbox"
              v-model="model.is_tax_responsed_by_company"
            />
            <label class="form-col-label control-label col-md-5">{{
              $t("employeeProfile.isTaxResponsedByCompany")
            }}</label>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-5"></label>
          <div class="col-md-7 tw-space-x-2">
            <input type="checkbox" v-model="model.is_spouse_dependant" />
            <label class="form-col-label control-label col-md-5">{{
              $t("employeeProfile.isSpouseDependant")
            }}</label>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-5">{{
            $t("employeeProfile.chilDependant")
          }}</label>
          <div class="col-md-7">
            <input
              type="number"
              v-model.number="model.num_child_dependant"
              class="form-control"
              :class="{
                'is-invalid': errors.has('num_child_dependant'),
              }"
            />
            <div
              class="invalid-feedback"
              v-if="errors.has('num_child_dependant')"
            >
              {{ errors.first("num_child_dependant") }}
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-6 tw-space-y-4">
        <div class="row">
          <label class="form-col-label control-label col-md-5">
            {{ $t("employeeProfile.payrollCycleDate") }}
          </label>
          <div class="col-md-7">
            <select
              v-model="model.pc_date_id"
              class="form-select"
              :class="{ 'is-invalid': errors.has('pc_date_id') }"
            >
              <option :value="null" disabled selected style="display: none">
                {{ $t("select") }}
              </option>
              <option
                v-for="(pcDate, index) in formViewDatas.payrollCycleDate"
                :key="index"
                :value="pcDate.pc_date_id"
              >
                {{ pcDate.pc_date_name }}
              </option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('pc_date_id')">
              {{ errors.first("pc_date_id") }}
            </div>
          </div>
        </div>
        <div class="row">
          <label class="form-col-label control-label col-md-5">
            {{ $t("employeeProfile.paymentType") }}
          </label>
          <div class="col-md-7">
            <select
              v-model="model.payment_type_id"
              class="form-select"
              :class="{
                'is-invalid': errors.has('payment_type_id'),
              }"
            >
              <option :value="null" disabled selected style="display: none">
                {{ $t("select") }}
              </option>
              <option
                v-for="(paymentType, index) in formViewDatas.paymentType"
                :key="index"
                :value="paymentType.payment_type_id"
              >
                {{ paymentType.payment_type }}
              </option>
            </select>
            <div class="invalid-feedback" v-if="errors.has('payment_type_id')">
              {{ errors.first("payment_type_id") }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Errors } from "form-backend-validation";
import { mapState } from "vuex";

export default {
  name: "payroll",
  props: ["value", "validation"],
  data() {
    return {
      model: {},
      errors: new Errors(),
    };
  },
  created() {
    this.model = this.value;
  },
  computed: {
    ...mapState("humanResource/employeeProfile", [
      "formViewDatas",
      "edit_data",
    ]),
  },
  watch: {
    validation: {
      handler() {
        this.errors = new Errors(this.validation.errors);
      },
      deep: true,
    },
  },
};
</script>
<style lang="css" scoped>
.section-divider-underline {
  padding-bottom: 5px;
  margin: 0 0 8px 0;
  /* border-bottom: 1px solid #eee; */
  font-size: 16px;
  color: #929090;
  font-weight: 400;
  text-transform: uppercase;
}
</style>
